<template>
	<type-wrapper class="type-C" limit :bgUrl="showData.image">
		<type-grid row="1" margin v-if="showData.title">
			<type-title large>{{ showData.title }}</type-title>
		</type-grid>
		<type-grid row="2" margin style="text-align: center;" v-if="mainPicture">
			<type-image mode="widthFix" :src="mainPicture"></type-image>
			<type-button round style="margin-top: 20px;" :style="buttonStyle[0]" v-if="showData.is_button" :whitebackdrop="whitebackdrop" @click="jumpAction(showData)">{{ showData.btn_text }}</type-button>
		</type-grid>
		<type-grid :row="mainPicture ? 2 : 1" margin>
			<template v-for="(item, index) in showData.block">
				<div :key="index">
					<type-title medium left v-if="item.title">{{ item.title }}</type-title>
					<type-content large :style="contentColor" v-if="item.content">{{ item.content }}</type-content>
				</div>
			</template>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 二分左图右文
	import mixin from '../mixin.js'
	export default {
		name: 'type-C',
		mixins: [ mixin ],
		computed: {
			mainPicture() {
				return this.showData.photo || '';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-C{
		display: flex;
		flex-wrap: wrap;
	}
</style>
